<!-- Show Add to Cart button if no cart item or quantity is 0 -->
@if ((matchedCartItem()?.quantity ?? 0) > 0) { @if (matchedCartItem(); as matchedItem) {
<div class="det-input-block" (click)="$event.stopPropagation()">
    <base-add-to-cart-input (click)="$event.stopPropagation()" [value]="matchedItem.quantity!" (increase$)="increaseQuantity($event, matchedItem.id!)" (decrease$)="decreaseQuantity($event, matchedItem.id!)" (quantityChanged$)="updateQuantity($event, matchedItem.id!)"></base-add-to-cart-input>
    <!-- {{ matchedItem.quantity }} Added -->
</div>
} } @else {
<!-- Show Add Button -->
<!-- PLUS ICON - Always show plus icon regardless of stock status -->
@if (isDisplayPlusImage()) {
<div class="instant-cart-action-btn" [class.disabled]="!product().in_stock && !product().is_allow_back_orders" (click)="
    (product().in_stock || product().is_allow_back_orders) && searchCart(product());
    $event.stopPropagation()
  " [attr.aria-label]="
    product().in_stock
      ? 'Add to cart'
      : product().is_allow_back_orders
      ? 'Pre order'
      : 'Coming soon'
  ">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="cart-action-btn-w-25 cart-action-btn-h-25 fill-current" [class.opacity-50]="!product().in_stock && !product().is_allow_back_orders">
        <path d="M6.39 0h3.22v6.39H16v3.22H9.61V16H6.39V9.61H0V6.39h6.39V0Z"></path>
    </svg>
</div>
}

<!-- TEXT BUTTONS - Handle all states -->
@if (isDisplayAddToCartText()) {
<!-- In Stock -->
@if (product().in_stock) {
<div (click)="searchCart(product()); $event.stopPropagation()" class="add-to-cart-button add-to-cart-button-background add-to-cart-button-border add-to-cart-button-border-top-left-radius add-to-cart-button-border-top-right-radius add-to-cart-button-border-bottom-right-radius add-to-cart-button-border-bottom-left-radius" aria-label="Add to cart">
    <span class="add-to-cart-button-label-size add-to-cart-button-font-weight add-to-cart-button-label-color desktop-view">
        Add to Cart
    </span>
    <span class="add-to-cart-button-label-size add-to-cart-button-font-weight add-to-cart-button-label-color mobile-view">
        + ADD
    </span>
</div>
}

<!-- Pre Order -->
@if (!product().in_stock && product().is_allow_back_orders) {
<div class="add-to-cart-button add-to-cart-button-background add-to-cart-button-border add-to-cart-button-border-top-left-radius add-to-cart-button-border-top-right-radius add-to-cart-button-border-bottom-right-radius add-to-cart-button-border-bottom-left-radius" (click)="searchCart(product()); $event.stopPropagation()" aria-label="Pre order">
    <span class="add-to-cart-button-label-size add-to-cart-button-font-weight add-to-cart-button-label-color desktop-view">
        Pre Order
    </span>
    <span class="add-to-cart-button-label-size add-to-cart-button-font-weight add-to-cart-button-label-color mobile-view">
        Pre Order
    </span>
</div>
}

<!-- Coming Soon -->
@if (!product().in_stock && !product().is_allow_back_orders) {
<div class="disabled add-to-cart-button add-to-cart-button-background add-to-cart-button-border add-to-cart-button-border-top-left-radius add-to-cart-button-border-top-right-radius add-to-cart-button-border-bottom-right-radius add-to-cart-button-border-bottom-left-radius" aria-label="Coming soon">
    <span class="add-to-cart-button-label-size add-to-cart-button-font-weight add-to-cart-button-label-color desktop-view">
        Coming Soon
    </span>
    <span class="add-to-cart-button-label-size add-to-cart-button-font-weight add-to-cart-button-label-color mobile-view">
        Upcoming
    </span>
</div>
} } }